var map = {
	"./76ers.png": 1502,
	"./Bucks.png": 9033,
	"./Bulls.png": 8398,
	"./Cavaliers.png": 5466,
	"./Celtics.png": 5665,
	"./Clippers.png": 6668,
	"./Grizzlies.png": 8643,
	"./Hawks.png": 1991,
	"./Heat.png": 1240,
	"./Hornets.png": 8197,
	"./Jazz.png": 3644,
	"./Kings.png": 86,
	"./Knicks.png": 5127,
	"./Lakers.png": 5429,
	"./Magic.png": 1816,
	"./Mavericks.png": 7493,
	"./Nets.png": 9391,
	"./Nuggets.png": 6043,
	"./Pacers.png": 2599,
	"./Pelicans.png": 9421,
	"./Pistons.png": 3298,
	"./Raptors.png": 9549,
	"./Rockets.png": 539,
	"./Spurs.png": 1665,
	"./Suns.png": 8638,
	"./Thunder.png": 4206,
	"./Timberwolves.png": 595,
	"./Trail Blazers.png": 8730,
	"./Warriors.png": 1329,
	"./Wizards.png": 6688
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 891;